import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'
import { ElNotification, ElMessage } from 'element-plus'
const TokenKey = 'Admin-Token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token: string) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

const no401Paths = ['/login']

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';


// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: import.meta.env.VITE_BASE_URL,
    // 超时
    timeout: 1000000
})
// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof (value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        url += subPart + encodeURIComponent(value[key]) + "&";
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    const newData = {
        ...res.data,
        msg: res.data.message,
    }
    return newData;
},
    error => {
        const resp = error.response;

        // 非网络错误
        if (resp.data?.code) {
            const msg = resp.data.message;
            const path = resp.data.path;
            ElNotification({
                message: msg,
                type: 'error',
                duration: 5 * 1000
            })
            if (resp.status === 401 && !no401Paths.includes(path)) {
                removeToken()
                router.push('/login')
                return Promise.reject()
            }
            if (resp.status === 500) {
                return Promise.reject(new Error(msg))
            } else {

                return Promise.reject('error')
            }
        }
        let { message } = error.message;

        if (message == "Network Error") {
            message = "后端接口连接异常";
        }
        else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        }
        else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        ElNotification({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
